import { BaseModel } from "sjs-base-model";

export default class CommissioniBancaSegnalanteFormModel extends BaseModel {
    public readonly reportingBankCommissionsPercentage: string = "";
    public readonly reportingBankCommissionsAmount: string = "";

    constructor(data: Partial<CommissioniBancaSegnalanteFormModel>) {
        super();

        this.update(data);
    }
}
